module.exports = __webpack_public_path__ + "static/media/embed-button-es.14b93dbe.jpg";